// Feature flags - defaults to false in production if env vars are not set
export const FEATURE_COSMO_CHAT = import.meta.env.VITE_FEATURE_COSMO_CHAT === 'true';
export const FEATURE_COUNCIL = import.meta.env.VITE_FEATURE_COUNCIL === 'true';
